var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GuardGroups'
      }
    }
  }, [_vm._v("群組保護")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("衛兵狀態列表")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("衛兵狀態列表")]), _c('div', {
    staticClass: "row d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-4 d-flex my-3"
  }, [_c('h6', {
    staticClass: "mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("狀態")]), _vm._l(_vm.statusOptions, function (i) {
    return _c('b-form-checkbox', {
      key: i.value,
      staticClass: "ml-2",
      attrs: {
        "value": i.value
      },
      on: {
        "change": _vm.fetchGuards
      },
      model: {
        value: _vm.selectedStatus,
        callback: function callback($$v) {
          _vm.selectedStatus = $$v;
        },
        expression: "selectedStatus"
      }
    }, [_vm._v(" " + _vm._s(i.text) + " ")]);
  })], 2), _c('div', {
    staticClass: "\n            col-12 col-xl-6\n            d-flex\n            flex-column flex-xl-row\n            align-items-start align-items-xl-center\n            my-3\n          "
  }, [_c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋姓名／手機"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGuards();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.fetchGuards();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.guards,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "head(report_at)",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "d-flex cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.handleSort('report_at');
            }
          }
        }, [_vm._v(" 回報狀態時間 "), _c('sort-caret', {
          attrs: {
            "status": _vm.sortBy === 'report_at' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "head(event_at)",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "d-flex cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.handleSort('event_at');
            }
          }
        }, [_vm._v(" 回報事件時間 "), _c('sort-caret', {
          attrs: {
            "status": _vm.sortBy === 'event_at' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "head(team)",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "d-flex cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.handleSort('team');
            }
          }
        }, [_vm._v(" Team "), _c('sort-caret', {
          attrs: {
            "status": _vm.sortBy === 'team' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "head(role)",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "d-flex cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.handleSort('role');
            }
          }
        }, [_vm._v(" Role "), _c('sort-caret', {
          attrs: {
            "status": _vm.sortBy === 'role' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [!data.item.isEditing ? [_c('router-link', {
          attrs: {
            "to": {
              name: 'GuardDetail',
              params: {
                guardID: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(data.item.display_name))]), _c('br'), _vm._v(" " + _vm._s(data.item.display_status) + " ")] : [_c('b-form-input', {
          staticClass: "mb-2 mr-sm-2 mb-sm-0",
          attrs: {
            "type": "text"
          },
          model: {
            value: data.item.display_name,
            callback: function callback($$v) {
              _vm.$set(data.item, "display_name", $$v);
            },
            expression: "data.item.display_name"
          }
        }), _c('br'), _c('b-form-input', {
          staticClass: "mb-2 mr-sm-2 mb-sm-0",
          attrs: {
            "type": "text"
          },
          model: {
            value: data.item.display_status,
            callback: function callback($$v) {
              _vm.$set(data.item, "display_status", $$v);
            },
            expression: "data.item.display_status"
          }
        })]];
      }
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [!data.item.isEditing ? [_c('b-img-lazy', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !!data.item.avatar_url,
            expression: "!!data.item.avatar_url"
          }],
          staticClass: "rounded-circle",
          attrs: {
            "src": data.item.avatar_url
          }
        }, 'b-img-lazy', _vm.mainProps, false))] : [_c('b-form-input', {
          staticClass: "mb-2 mr-sm-2 mb-sm-0",
          attrs: {
            "type": "text"
          },
          model: {
            value: data.item.avatar_url,
            callback: function callback($$v) {
              _vm.$set(data.item, "avatar_url", $$v);
            },
            expression: "data.item.avatar_url"
          }
        })]];
      }
    }, {
      key: "cell(guard_status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.statusEnum(data.item.guard_status).variant
          }
        }, [_vm._v(_vm._s(_vm.statusEnum(data.item.guard_status).text))])];
      }
    }, {
      key: "cell(report_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.report_at)) + " ")];
      }
    }, {
      key: "cell(role)",
      fn: function fn(data) {
        return [!data.item.isEditing ? [_vm._v(" " + _vm._s(data.item.role) + " ")] : [_c('b-form-input', {
          staticClass: "mb-2 mr-sm-2 mb-sm-0",
          attrs: {
            "type": "text",
            "readonly": !data.item.isEditing
          },
          model: {
            value: data.item.role,
            callback: function callback($$v) {
              _vm.$set(data.item, "role", $$v);
            },
            expression: "data.item.role"
          }
        })]];
      }
    }, {
      key: "cell(team)",
      fn: function fn(data) {
        return [!data.item.isEditing ? [_vm._v(" " + _vm._s(data.item.team) + " ")] : [_c('b-form-input', {
          staticClass: "mb-2 mr-sm-2 mb-sm-0",
          attrs: {
            "type": "text",
            "readonly": !data.item.isEditing
          },
          model: {
            value: data.item.team,
            callback: function callback($$v) {
              _vm.$set(data.item, "team", $$v);
            },
            expression: "data.item.team"
          }
        })]];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [data.item.isEditing ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "primary",
            "size": "md"
          },
          on: {
            "click": function click($event) {
              return _vm.updateGuardReport(data.item);
            }
          }
        }, [_vm._v("確定更新 ")]) : _vm._e(), !data.item.isEditing ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "danger",
            "size": "md"
          },
          on: {
            "click": function click() {
              return data.item.isEditing = true;
            }
          }
        }, [_vm._v("重設")]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }